import(/* webpackMode: "eager", webpackExports: ["PageHome"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/home/__page__/PageHome.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Mitobyte/Mitobyte/src/app/page.module.css");
